import type React from "react";

import { cn } from "src/shadcn/lib/utils";
import {
  TableHeader as ShadcnTableHeader,
  TableBody as ShadcnTableBody,
  TableFooter as ShadcnTableFooter,
  TableHead as ShadcnTableHead,
  TableRow as ShadcnTableRow,
  TableCell as ShadcnTableCell,
  TableCaption as ShadcnTableCaption,
} from "src/shadcn/components/table";

const Table = ({ className, ...props }: React.ComponentProps<"table">) => (
  <div data-slot="table-container" className="relative w-full">
    <table
      data-slot="table"
      className={cn("w-full caption-bottom text-sm", className)}
      {...props}
    />
  </div>
);

const TableHeader = (props: React.ComponentProps<typeof ShadcnTableHeader>) => (
  <ShadcnTableHeader {...props} />
);

const TableBody = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnTableBody>) => (
  <ShadcnTableBody
    className={cn("[&_tr]:border-border", className)}
    {...props}
  />
);

const TableFooter = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnTableFooter>) => (
  <ShadcnTableFooter className={cn("border-border", className)} {...props} />
);

const TableHead = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnTableHead>) => (
  <ShadcnTableHead className={cn("h-11 px-3", className)} {...props} />
);

const TableRow = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnTableRow>) => (
  <ShadcnTableRow className={cn("border-border", className)} {...props} />
);

const TableCell = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnTableCell>) => (
  <ShadcnTableCell className={cn("px-3 py-2.5", className)} {...props} />
);

const TableCaption = (
  props: React.ComponentProps<typeof ShadcnTableCaption>
) => <ShadcnTableCaption {...props} />;

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
};
